import { useContext, useEffect, useState } from 'react';
import '../../styles/wlair.css';
import TripleOaksProvider, { TripleOaksContext } from './TripleOaksProvider';
import { SlotDrag } from '../../components/cursor/draggables/SlotDrag';
import { ASCII } from '../../components/ASCII';
import webmaster from 'url:../../assets/ascii/webmaster.txt';
import AnimeDivider from '../../components/AnimeDivider';
import { GouchField } from '../../components/GouchField';
import code from 'url:../../assets/webdings1.png';
import notcode from 'url:../../assets/webdings2.png';
import { SiteUpdates } from '../../components/SiteUpdate';

export function WebmastersLair (props : { })
{
    const trokContext = useContext<TripleOaksContext>(TripleOaksProvider.context);
    const [seen, setSeen] = useState(trokContext.lair);
    const [revealed, setRevealed] = useState(trokContext.revealed);

    useEffect(() => {
        setSeen(trokContext.lair);
        setRevealed(trokContext.revealed);
    }, [trokContext]);

    const revealedSection = <div className=''>
        <br/><br/><br/><br/><br/>
        <h3>WELCOME … TO YOUR DOOM!!</h3>

        <br/><br/>

        <p>Just Kidding...</p> 
        <br/>

        <div className='wlair-red'>STOP!!</div>

        <img src={code} />

        <br/><br/><br/>
        <h3>Welcome… TO MY HOME!!!</h3>
        
        <p>You found me!</p>

        <p>I am the Webmaster of this site! Nice to meet you. This is my little corner of the world. I’d enjoy pina coladas and getting lost in the rain if I wasn’t stuck in my computer rofl. I help the local folks out by maintaining this website, so if you see anything weird, let me know! I’ll make it worse! Just joshing. See, isn’t this fun already? Are you having fun? Better start! </p>

        <br/><br/>

        <img src={notcode} />

        <br/><br/><br/>
        <br/>
        <SlotDrag 
            id='wlair-webmaster' 
            slot='wlair-webmaster-slot'
            lock={true}>
            <ASCII id={'wlair-webmaster'} ascii={webmaster} />
        </SlotDrag>
        <br/>
        <p><i>Artist's rendition of the artist</i></p>

        <br/><br/><br/>

        <p>Things I’ve been Enjoying Lately [4-15-99]</p>
        <ul>
            <li><p>iSpy books</p></li>
            <li><p>Trolling forums</p></li>
            <li><p>Hiding things from my boss shhhh</p></li>
            <li><p>This new website called Napster. There’s so much music on there! <a href="/">Check it!!!</a></p></li>
        </ul>

        <br/><br/><br/>

        <SiteUpdates
            headerContents={
                <h2>Site Updates</h2>
            }
            updates={[
                {
                    headerContents: <h3>2-5-2001</h3>,
                    bodyContents: <p>Going dark. Apparently my web design is too “unprofessional” and “whimsical.” Site will no longer be maintained. I was asked to stop updates to avoid confusion, so I’m just gonna bounce. If you know where to find me, find me there. Smell ya later.</p>
                },
                {
                    headerContents: <h3>1-8-2000</h3>,
                    bodyContents: <p>Town received a grant for modernization! I’m told this means we can build a brand new, beautiful site. Many pages going under construction to test new styling. Do not be alarmed! </p>
                },
                {
                    headerContents: <h3>1-1-2000</h3>,
                    bodyContents: <p>Can anyone hear me in the new millennium? Did we survive? If we can do that together, we can do anything. Invented hoverboards and that robot dog from the Jetsons. Website didn’t crash. HAPPY NEW YEAR!</p>
                },
                {
                    headerContents: <h3>12-31-1999</h3>,
                    bodyContents: <p>Oops lol I thought there were 30 days in December. THIS IS MY FINAL MESSAGE. SEE YOU IN THE FUTURE… I HOPE.</p>
                },
                {
                    headerContents: <h3>12-30-1999</h3>,
                    bodyContents: <p>If all the tech goes away at midnight, know that this has been da bomb. I’ll miss you Triple Oaks! ZEEP ZOOB FOR4EVER. </p>
                },
                {
                    headerContents: <h3>11-24-1999</h3>,
                    bodyContents: <p>Added cursor effects and dog that follows your mouse around. Gonna spend time on my side projects for the holidays in case the whole internet blows up, and I can’t do this anymore.  </p>
                },
                {
                    headerContents: <h3>9-1-1999</h3>,
                    bodyContents: <p>Oh snap! Thanks for all the quotes! I got soooooo many. Keep them coming, especially if you have one you want to send but were worried I’d be overwhelmed. I’m not, so keep ‘em coming. </p>
                },
                {
                    headerContents: <h3>8-27-1999</h3>,
                    bodyContents: <p>Added a daily quotes section. Send me your favorites, and you might see them on the town website! </p>
                },
                {
                    headerContents: <h3>8-1-1999</h3>,
                    bodyContents: <p>Added some side projects to the web ring. Go support my friends, or add us to yours! </p>
                },
                {
                    headerContents: <h3>7-18-1999</h3>,
                    bodyContents: <p>Updated community calendar. Added a music player! Been finding lots of cool music on Naps and wanted to share it.</p>
                },
                {
                    headerContents: <h3>6-20-1999</h3>,
                    bodyContents: <p>Poke poke</p>
                },
                {
                    headerContents: <h3>6-17-1999</h3>,
                    bodyContents: <p>Added visitor counter to the site. We may be a small town, but we’re the life of the party once you get to know us. I wonder if Kevin is one of those numbers.</p>
                },
                {
                    headerContents: <h3>6-15-1999</h3>,
                    bodyContents: <p>I’ve added an extra period somewhere on this website. Email me if you find it, and I’ll give you a prize.</p>
                },
                {
                    headerContents: <h3>6-10-1999</h3>,
                    bodyContents: <p>Moved community calendar to its own page so the home page is cleaner. </p>
                },
                {
                    headerContents: <h3>6-1-1999</h3>,
                    bodyContents: <p>Kevin moved away, so it’s just you and me everyone. When the cat’s away, eh? As Kevin used to say, “The show must go on.”</p>
                },
                {
                    headerContents: <h3>5-12-1999</h3>,
                    bodyContents: <p>Added URL not found page, sprinkled a little fun in. </p>
                },
                {
                    headerContents: <h3>4-1-1999</h3>,
                    bodyContents: <p>Psyche!! ROFLOL everyone calm down. I was just yankin your chain. I am fine. All belong to Planet Zeep Zoob though.</p>
                },
                {
                    headerContents: <h3>4-1-1999</h3>,
                    bodyContents: <p>Ughhhh what happened?? How long was I out. My computer blue screened and I heard a terrible sound. Wait- why is everything on the page space themed? Did one of you do this?</p>
                },
                {
                    headerContents: <h3>4-1-1999</h3>,
                    bodyContents: <p>Beep boop. I am an alien from a distant galaxy. I heard about your “cool” webbed site and have taken it for my planet. All belong to Planet Zeep Zoob!! ZEEEEEEEEEP!!! I have abducted your web’s master for experiments.</p>
                },
                {
                    headerContents: <h3>3-3-1999</h3>,
                    bodyContents: <p>improved performance, fixed typo on community calendar- k</p>
                },
                {
                    headerContents: <h3>1-8-1999</h3>,
                    bodyContents: <p>News archive added, now hosts articles from the not too distant past. I feel like an old timey paper boy. Extra Extra! Read all about our fun little town!</p>
                },
                {
                    headerContents: <h3>9-10-1998</h3>,
                    bodyContents: <p>Changed theme for fall, leaves are now orange. Updated Community Calendar for the holidays! What are you going to get me?</p>
                },
                {
                    headerContents: <h3>7-19-1998</h3>,
                    bodyContents: <p>Changed home page display, width of boxes expanded</p>
                },
                {
                    headerContents: <h3>5-16-1998</h3>,
                    bodyContents: <p>updated tourism mentions to be compliant -k</p>
                },
                {
                    headerContents: <h3>4-2-1998</h3>,
                    bodyContents: <p>Website is normal again :\</p>
                },
                {
                    headerContents: <h3>4-1-1998</h3>,
                    bodyContents: <p>APRIL FOOLS! I was never in a hot air balloon. Did I fool you? Will change the balloon images and cursor back tomorrow.</p>
                },
                {
                    headerContents: <h3>4-1-1998</h3>,
                    bodyContents: <p>I’m giving up web design to travel the world in a hot air balloon. This website is now to catalogue my travels. I am reaching out through the world’s longest ethernet cable.
                        <br/><br/>
                        Traveller’s Log Day 1. It is cold up here, despite the fire inflating my hot air balloon with hot air. You would think hot air balloons would be hotter. Everything looks so small from up here. Little ants going about their business, instead of freezing to death in a wicker basket in the sky. The town of Triple Oaks is but a blip on the map now, a place I am from not a place that I am
                        <br/><br/>
                        Traveller’s Log Day 2: I am beginning to wonder if I should have planned more for this venture. Hunger encroaches from every angle. I am like the fire that keeps me afloat, insatiable. I propel others to new heights, but what am I? A void for fuel? At least I am a whimsical one.
                    </p>
                },
                {
                    headerContents: <h3>2-25-1998</h3>,
                    bodyContents: <p>Updated What To Do and Home for notable tourism spots and highlights.</p>
                },
                {
                    headerContents: <h3>12-30-1997</h3>,
                    bodyContents: <p>kevin page removed -k</p>
                },
                {
                    headerContents: <h3>10-31-1997</h3>,
                    bodyContents: <p>Ate too much candy… but just one more byte ROFL. Happy Halloween!</p>
                },
                {
                    headerContents: <h3>10-23-1997</h3>,
                    bodyContents: <p>Trick or Treating schedule uploaded. Added Halloween icons for atmosphere. Be safe, and don’t forget to check your candy! Trick or Treat for Unicef boxes available at library.</p>
                },
                {
                    headerContents: <h3>10-13-1997</h3>,
                    bodyContents: <p>Updated Home to include founder’s story. Said Flushle so much it no longer sounds real. Flushle Flushle flushle flushle flushle flushle</p>
                },
                {
                    headerContents: <h3>9-18-1997</h3>,
                    bodyContents: <p>Added Kevin page again. Thanks Mrs Gunkley for the help! Now Kevin will never find it muhahaha </p>
                },
                {
                    headerContents: <h3>9-15-1997</h3>,
                    bodyContents: <p>kevin page removed -k</p>
                },
                {
                    headerContents: <h3>9-3-1997</h3>,
                    bodyContents: <p>What To Do section, Site Map added, Kevin Is My Best Friend page added</p>
                },
                {
                    headerContents: <h3>8-26-1997</h3>,
                    bodyContents: <p>New author appears! Hello! I will be taking the seat of Webmaster from this point on. Thanks for keeping my cyber seat warm, Kevin. I’m just a hobbyist helping out my friends who work for the town, so everyone be nice! :3</p>
                },
                {
                    headerContents: <h3>8-23-1997</h3>,
                    bodyContents: <p>roger. test a success. don’t yell lol -k</p>
                },
                {
                    headerContents: <h3>8-22-1997</h3>,
                    bodyContents: <p>TEST TEST TEST TEST!!! CAN YOU HEAR ME NOW??</p>
                },
                {
                    headerContents: <h3>8-21-1997</h3>,
                    bodyContents: <p>site performance issues resolved. help brought on to maintain site. last update was a test - k</p>
                },
                {
                    headerContents: <h3>8-20-1997</h3>,
                    bodyContents: <p>Can you hear me?</p>
                },
                {
                    headerContents: <h3>5-14-1997</h3>,
                    bodyContents: <p>typos fixed, broken links updated -k</p>
                },
                {
                    headerContents: <h3>3-5-1997</h3>,
                    bodyContents: <p>town logo updated -k</p>
                },
                {
                    headerContents: <h3>1-10-1997</h3>,
                    bodyContents: <p>site launched</p>
                }
            ]}
        />
    </div>

    return seen ? <div className='wlair-page'>
        <WebmasterBackground />
        <div className='wlair-content'>
            <h1>THE WEBMASTER'S LAIR</h1>
            <AnimeDivider />
            {
                revealed ? revealedSection : null
            }
            <div className='wlair-gap' />
        </div>
        <GouchField onTarget={
            () => {
                trokContext.setRevealed(true);
            }
        } />
    </div> : null
}

function WebmasterBackground ()
{
    const trokContext = useContext<TripleOaksContext>(TripleOaksProvider.context);

    return <div className='wlair-bg'>
        <div className='wlair-bg-crack' />
        <div className='wlair-bg-exit-a' onClick={() => { 
            trokContext.setLair(false); 
        }} />
        <div className='wlair-bg-exit-b' onClick={() => { 
            trokContext.setLair(false); 
        }} />
        <div className='wlair-bg-tr' />
        <div className='wlair-bg-bot' />
    </div>
}